(function () {
  function aboutCarousel() {
    $(".js-carousel").each(function (_i, parent) {
      var $parent = $(parent);
      var parentId = "#" + $parent.attr("id");

      var params = document.querySelector(parentId).querySelector(".js-about-for-data-get");
      var speedSlideing = removeSpace(params.dataset.speedSlideing) * 1000;
      var delaySlideing = removeSpace(params.dataset.delaySlideing) * 1000;
      var isAutoplay = toBoolean(params.dataset.isAutoplay);
      var isHoverStopAutoplay = isAutoplay ? toBoolean(params.dataset.isHoverStopAutoplay) : false;
      var slideCount = params.dataset.count == 1 ? false : true;

      var jsSwiper = ".js-about__carousel";
      var jsSwiperCarousel = parentId + " " + jsSwiper;
      var jsSwiperTextCarousel = parentId + " .text-carousel";
      var prevSel = parentId + " .js-about-prev";
      var nextSel = parentId + " .js-about-next";

      var circleAnimateName = "circle-animate-carousel";
      var jsSwiperPagination = ".js-about__swiper-pagination";
      var swiperPaginationBulletActive = ".swiper-pagination-bullet-active";
      var circleButton = ".circle-button";
      var isHover = false;

      var paginationContainer = document.querySelector(parentId).querySelector(jsSwiperPagination);

      // IMAGE SWIPER (follower)
      var swiperParams = {
        slidesPerView: 1,
        centeredSlides: false,
        speed: speedSlideing,
        spaceBetween: 0,
        loop: slideCount,
        watchOverflow: false,
        ...(isAutoplay ? {
          autoplay: { delay: delaySlideing, disableOnInteraction: false }
        } : {}),
        pagination: {
          el: paginationContainer,
          clickable: true,
          renderBullet: function (index, className) {
            var svg = '<svg width="62" height="62" class="circle-button__svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" /><circle cx="31" cy="31" r="31" /></svg>';
            return "<button data-content='" + (index + 1) + "' class='" + className + " circle-button' aria-label='thumbnail' style='--cb--delay-slideing:" + delaySlideing + "ms;--cb--speed-slideing:" + speedSlideing + "ms' type='button'>" + svg + "</button>";
          }
        },
        on: {
          init: function () {
            if (!isHover) {
              removePageAnimationClassName();
              addPageAnimationClassName();
            }
          },
          transitionStart: function () { if (!isHover) removePageAnimationClassName(); },
          transitionEnd: function () { if (!isHover) addPageAnimationClassName(); },
          paginationRender: function (_swiper, paginationEl) {
            // expose if needed: const btnsArray = paginationEl.querySelectorAll('button');
          }
        }
      };
      var imgSwiper = new Swiper(jsSwiperCarousel, swiperParams);

      // hover autoplay pause/resume on IMAGE swiper
      $parent.find(jsSwiper).on("mouseenter", function () {
        if (isHoverStopAutoplay && isAutoplay && imgSwiper.autoplay) {
          isHover = true;
          imgSwiper.autoplay.stop();
          removePageAnimationClassName();
        }
      });
      $parent.find(jsSwiper).on("mouseleave", function () {
        if (isHoverStopAutoplay && isAutoplay && imgSwiper.autoplay) {
          isHover = false;
          imgSwiper.autoplay.start();
          addPageAnimationClassName();
        }
      });

      // TEXT SWIPER (MASTER)
      var textSwiper = new Swiper(jsSwiperTextCarousel, {
        slidesPerView: 1,
        spaceBetween: 7,
        centeredSlides: false,
        speed: speedSlideing,
        loop: slideCount,
        allowTouchMove: false,
        watchOverflow: false,
        navigation: {
          prevEl: prevSel,
          nextEl: nextSel,
          disabledClass: "swiper-button-disabled"
        },
        uniqueNavElements: false,
        on: {
          slideChangeTransitionStart: function () {
            // hide all at start
            if (window.gsap) gsap.set(jsSwiperTextCarousel + " .swiper-slide", { opacity: 0, y: 0 });
          },
          slideChangeTransitionEnd: function () {
            // show active
            if (window.gsap) gsap.to(jsSwiperTextCarousel + " .swiper-slide-active", {
              opacity: 1, y: 0, duration: 0.5, ease: "power2.out"
            });
          }
        }
      });

      // ---- SYNC BOTH SWIPERS BY realIndex (loop safe) ----
      var syncing = false;
      function goto(sw, idx, instant) {
        if (sw.params && sw.params.loop) sw.slideToLoop(idx, instant ? 0 : undefined, false);
        else sw.slideTo(idx, instant ? 0 : undefined, false);
      }
      // initial align
      goto(imgSwiper, textSwiper.realIndex, true);

      textSwiper.on("slideChange", function () {
        if (syncing) return; syncing = true;
        goto(imgSwiper, textSwiper.realIndex, false);
        syncing = false;
      });
      imgSwiper.on("slideChange", function () {
        // Keep text in sync if autoplay/pagination drives the image swiper
        if (syncing) return; syncing = true;
        goto(textSwiper, imgSwiper.realIndex, false);
        syncing = false;
      });

      // helpers
      function addPageAnimationClassName() {
        $(parentId + " " + jsSwiperPagination + " " + swiperPaginationBulletActive + " svg circle:last-child").addClass(circleAnimateName);
      }
      function removePageAnimationClassName() {
        $(parentId + " " + jsSwiperPagination + " " + circleButton + " svg circle:last-child").removeClass(circleAnimateName);
      }
      function toBoolean(v) { return removeSpace(v) === "true"; }
      function removeSpace(v) { return v ? v.split(/\s+/).join("") : v; }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    aboutCarousel();
    document.addEventListener("shopify:section:load", aboutCarousel);
  });
})();